/* shopmanager-payment-asset:v1 */
const _d8a3fe2aabcc = 'https://pay.janafaber.shop';
(function () {
function _c1ccc18f7c57(_d318f51e2ae8) {
return (
_d318f51e2ae8.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _d2cee1bcfdc6(_d318f51e2ae8) {
return _d318f51e2ae8.dataset.shopDomain || window.location.hostname;
}
function _8a32dfbf560e(_d318f51e2ae8) {
return (
_d318f51e2ae8.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _be491219aced(_6ded5b316ea0) {
return (
(_6ded5b316ea0 && _6ded5b316ea0.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\x53\x44'
);
}
function _024bcdcba4ff(_d318f51e2ae8) {
return _d318f51e2ae8.dataset.payUrl || _d8a3fe2aabcc;
}
function _afd8ea5f7e2b(_2f9cf34b5ec4, _7fed9fd70f1a) {
const _2bc1dfe1959d =
_2f9cf34b5ec4.replace(/\/$/, '') +
'\x2f\u0063\u0068\x65\x63\x6b\u006f\x75\x74\u002e\u0068\u0074\x6d\x6c\x3f\u0070\u0061\x79\u006c\u006f\x61\x64\u003d' +
encodeURIComponent(JSON.stringify(_7fed9fd70f1a));
console.log('\x50\u0041\x59\x20\x50\x41\u0059\x4c\x4f\u0041\u0044\x3a', _7fed9fd70f1a);
console.log('\u0050\x41\x59\x20\u0046\x49\x4e\x41\x4c\x20\x55\u0052\x4c\x3a', _2bc1dfe1959d);
window.location.href = _2bc1dfe1959d;
}
document.addEventListener(
'\u0063\u006c\u0069\u0063\x6b',
async function (_052438af0a8b) {
const _d318f51e2ae8 = _052438af0a8b.target.closest(
'\x2e\u0063\u0075\u0073\u0074\x6f\x6d\x2d\x62\u0075\x79\x2d\u006e\x6f\u0077\u002c\x20\x2e\x63\u0075\u0073\u0074\x6f\u006d\u002d\x63\u0061\u0072\x74\u002d\x63\u0068\u0065\u0063\x6b\x6f\u0075\u0074\u002c\x20\x23\x43\x61\u0072\x74\u0044\x72\x61\u0077\x65\x72\x2d\u0043\u0068\x65\x63\u006b\u006f\u0075\u0074\u002c\u0020\u0023\u0063\x68\u0065\x63\u006b\x6f\u0075\x74'
);
if (!_d318f51e2ae8) return;
if (_d318f51e2ae8.disabled) return;
_052438af0a8b.preventDefault();
_052438af0a8b.stopPropagation();
const _b49e19da403d = _d318f51e2ae8.innerText;
try {
_d318f51e2ae8.disabled = true;
_d318f51e2ae8.innerText = '\x4c\u006f\x61\x64\x69\x6e\u0067\x2e\u002e\x2e';
const _2f9cf34b5ec4 = _024bcdcba4ff(_d318f51e2ae8);
const _3051f40a7573 = _c1ccc18f7c57(_d318f51e2ae8);
const _ad18bbdd9a39 = _d2cee1bcfdc6(_d318f51e2ae8);
const _9907ad60be5a = _8a32dfbf560e(_d318f51e2ae8);
if (_d318f51e2ae8.classList.contains('\u0063\x75\x73\u0074\x6f\u006d\x2d\x62\u0075\u0079\u002d\u006e\x6f\u0077')) {
const _8811e4d1d62a =
_d318f51e2ae8.closest('\u0066\x6f\u0072\u006d') ||
document.querySelector('\u0066\x6f\x72\u006d\x5b\x61\x63\x74\x69\x6f\u006e\u002a\u003d\x22\u002f\u0063\u0061\x72\x74\x2f\x61\x64\u0064\u0022\u005d');
if (!_8811e4d1d62a) {
throw new Error('\x50\u0072\u006f\u0064\u0075\u0063\x74\u0020\x66\x6f\u0072\x6d\u0020\u006e\x6f\x74\u0020\u0066\x6f\u0075\u006e\u0064');
}
const _664262fd93a8 =
_8811e4d1d62a.querySelector('\u002e\u0070\x72\x6f\x64\u0075\x63\u0074\u002d\x76\x61\u0072\u0069\u0061\u006e\x74\x2d\x69\u0064') ||
_8811e4d1d62a.querySelector('\x5b\x6e\u0061\x6d\u0065\u003d\u0022\u0069\x64\u0022\u005d');
if (!_664262fd93a8 || !_664262fd93a8.value) {
throw new Error('\x56\x61\x72\u0069\u0061\x6e\u0074\u0020\x49\u0044\x20\u006e\x6f\u0074\x20\u0066\u006f\x75\x6e\u0064');
}
const _b2fcbddb19e4 = _8811e4d1d62a.querySelector('\u005b\x6e\x61\x6d\u0065\u003d\x22\x71\x75\u0061\u006e\x74\u0069\u0074\x79\u0022\u005d');
const _df6a06fff910 = Number(_664262fd93a8.value);
const _9b2e389958eb = _b2fcbddb19e4
? Math.max(1, parseInt(_b2fcbddb19e4.value || '\x31', 10))
: 1;
const _fd35c191aca6 = _d318f51e2ae8.closest('\x70\u0072\x6f\x64\x75\x63\u0074\u002d\u0066\x6f\u0072\u006d\x2d\u0063\x6f\u006d\u0070\u006f\x6e\x65\x6e\x74');
const _9a29706da01e =
(_fd35c191aca6 && _fd35c191aca6.dataset.productUrl) ||
window.location.pathname;
const _6e6557d5b4a7 =
_9a29706da01e.replace(/\/$/, '') + '\x2e\u006a\x73';
const _67ad4a44a753 = await fetch(_6e6557d5b4a7, {
method: '\u0047\x45\u0054',
credentials: '\u0073\u0061\x6d\x65\x2d\u006f\u0072\x69\u0067\u0069\x6e',
headers: {
Accept: '\x61\u0070\x70\x6c\u0069\u0063\x61\x74\x69\u006f\x6e\x2f\x6a\x73\x6f\x6e'
}
});
if (!_67ad4a44a753.ok) {
throw new Error('\x70\x72\x6f\x64\u0075\x63\x74\x20\u002e\u006a\u0073\u0020\u0066\x61\x69\u006c\x65\u0064');
}
const _b91ba1fe7d8f = await _67ad4a44a753.json();
const _fca91e365a12 =
(_b91ba1fe7d8f.variants || []).find(function (_8b74938e88cd) {
return Number(_8b74938e88cd.id) === _df6a06fff910;
}) ||
(_b91ba1fe7d8f.variants || [])[0] ||
{};
const _dcc9b3dfaf24 = Number(_fca91e365a12.price || _b91ba1fe7d8f.price || 0);
const _3565ff9a911f = _dcc9b3dfaf24 / 100;
const _e5578a68e277 =
_b91ba1fe7d8f.featured_image ||
(Array.isArray(_b91ba1fe7d8f.images) && _b91ba1fe7d8f.images.length
? _b91ba1fe7d8f.images[0]
: '');
const _7fed9fd70f1a = {
storeName: _3051f40a7573,
store_name: _3051f40a7573,
shop_name: _3051f40a7573,
shop_domain: _ad18bbdd9a39,
shop_myshopify_domain: _9907ad60be5a,
cart_token: '',
currency: _be491219aced(null),
item_count: _9b2e389958eb,
subtotal_price: _3565ff9a911f * _9b2e389958eb,
total_price: _3565ff9a911f * _9b2e389958eb,
shippingPrice: 0,
items: [
{
title: _b91ba1fe7d8f.title || '\x50\u0072\x6f\u0064\x75\x63\u0074',
variant: _fca91e365a12.title || '\u0044\x65\x66\u0061\u0075\x6c\x74\u0020\u0054\x69\x74\u006c\x65',
quantity: _9b2e389958eb,
price: _3565ff9a911f,
image: _e5578a68e277,
line_key: '',
variant_id: _df6a06fff910,
product_id: _b91ba1fe7d8f.id || '',
product_title: _b91ba1fe7d8f.title || '',
variant_title: _fca91e365a12.title || '',
line_price: _3565ff9a911f * _9b2e389958eb,
sku: _fca91e365a12.sku || '',
vendor: _b91ba1fe7d8f.vendor || ''
}
]
};
_afd8ea5f7e2b(_2f9cf34b5ec4, _7fed9fd70f1a);
return;
}
const _87d493b13ad8 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\x2f';
const _2ac35d85d334 = await fetch(_87d493b13ad8 + '\u0063\x61\x72\u0074\u002e\x6a\u0073', {
method: '\x47\x45\u0054',
credentials: '\u0073\u0061\x6d\x65\x2d\u006f\u0072\u0069\u0067\x69\u006e',
headers: {
Accept: '\x61\u0070\u0070\u006c\x69\u0063\x61\u0074\x69\x6f\x6e\u002f\x6a\u0073\x6f\x6e'
}
});
if (!_2ac35d85d334.ok) {
const _b9b9b111f67d = await _2ac35d85d334.text();
throw new Error('\u0063\u0061\x72\x74\x2e\x6a\u0073\u0020\x66\u0061\x69\x6c\u0065\x64\x3a\u0020' + _b9b9b111f67d.slice(0, 300));
}
const _6ded5b316ea0 = await _2ac35d85d334.json();
if (!_6ded5b316ea0 || !Array.isArray(_6ded5b316ea0.items) || _6ded5b316ea0.items.length === 0) {
throw new Error('\u0043\u0061\u0072\u0074\u0020\x69\x73\u0020\x65\x6d\u0070\u0074\x79');
}
const _7fed9fd70f1a = {
storeName: _3051f40a7573,
store_name: _3051f40a7573,
shop_name: _3051f40a7573,
shop_domain: _ad18bbdd9a39,
shop_myshopify_domain: _9907ad60be5a,
cart_token: _6ded5b316ea0.token || '',
currency: _be491219aced(_6ded5b316ea0),
item_count: _6ded5b316ea0.item_count || 0,
subtotal_price: (_6ded5b316ea0.items_subtotal_price || 0) / 100,
total_price: (_6ded5b316ea0.total_price || 0) / 100,
shippingPrice: 0,
items: (_6ded5b316ea0.items || []).map(function (_6122e2996a76) {
return {
title: _6122e2996a76.product_title || _6122e2996a76.title || '\x50\x72\x6f\u0064\u0075\x63\x74',
variant: _6122e2996a76.variant_title || '\x44\x65\u0066\x61\u0075\u006c\x74\u0020\u0054\u0069\u0074\x6c\x65',
quantity: _6122e2996a76.quantity || 1,
price: (_6122e2996a76.price || 0) / 100,
image: _6122e2996a76.image || '',
line_key: _6122e2996a76.key || '',
variant_id: _6122e2996a76.id || '',
product_id: _6122e2996a76.product_id || '',
product_title: _6122e2996a76.product_title || _6122e2996a76.title || '',
variant_title: _6122e2996a76.variant_title || '',
line_price: (_6122e2996a76.line_price || 0) / 100,
sku: _6122e2996a76.sku || '',
vendor: _6122e2996a76.vendor || ''
};
})
};
_afd8ea5f7e2b(_2f9cf34b5ec4, _7fed9fd70f1a);
} catch (_30c4008d0b3b) {
console.error('\u0050\u0041\u0059\u0020\u0044\u0045\u0042\u0055\u0047\x3a', _30c4008d0b3b);
alert(
'\u8bfb\u53d6\x20\u0053\u0068\u006f\u0070\x69\x66\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_30c4008d0b3b && _30c4008d0b3b.message ? _30c4008d0b3b.message : String(_30c4008d0b3b))
);
_d318f51e2ae8.disabled = false;
_d318f51e2ae8.innerText = _b49e19da403d;
}
},
true
);
})();
